module.exports = __webpack_public_path__ + "05_bob_brown.a21a3748.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_bob_brown.png
// module id = 8CsP
// module chunks = 0